const reducer = (state, action) => {
    switch (action.type) {
        case 'update':
            return { ...state, ...action.payload };
        case 'retrieving':
            return { ...state, isRetrieving: true };
        case 'retrieved':
            return { ...state, isRetrieving: false };
        case 'creating':
            return { ...state, isCreating: true };
        case 'createError':
            return { ...state, isCreating: false };
        default:
            return state;
    }
};

export default reducer;
